module.exports = __webpack_public_path__ + "img/11.4.NH3-N.f8a59950.png";